import { CustomField, CustomValue } from '@queries/generated';

export function customFieldRequired(
  field: Pick<CustomField, 'id' | 'required'>,
  values: Pick<CustomValue, 'value' | 'customFieldId'>[],
  required = false
) {
  if (!field.required && !required) {
    return false;
  }

  const hasValue = values.find((value) => field.id === value.customFieldId);
  return !hasValue || hasValue.value === '';
}

export function customFieldsRequired(
  fields: Pick<CustomField, 'id' | 'required'>[],
  values: Pick<CustomValue, 'value' | 'customFieldId'>[]
) {
  return fields
    .filter((field) => field.required)
    .some((field) => {
      return customFieldRequired(field, values);
    });
}
